import { isEqual } from 'lodash-es';
import axios from 'axios';

import store from '@store';

const normalizeBaseUrl = (url) => {
  if (!url) return '';
  return url.endsWith('/') ? url : `${url}/`;
};

const httpClient = axios.create({
  baseURL: `${normalizeBaseUrl(import.meta.env.VITE_APP_NEW_API_GATEWAY_API_URL)}v2`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

const reqInterceptor = (req) => {
  const legacyContentType = req?.data?.contentType;
  const customFlag = req?.contentType || legacyContentType;
  const requestedContentType = customFlag || 'application/json';

  const token = localStorage.getItem('GAV_accessToken');
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }

  if (!isEqual(requestedContentType, 'application/json')) {
    switch (requestedContentType) {
      case 'xlsx':
        req.responseType = 'blob';
        req.headers.Accept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        break;
      case 'link-xlsx':
      case 'csv':
        break;
      default:
        req.responseType = 'blob';
        break;
    }
  }
  if (isEqual(req.data?.constructor?.name?.toLowerCase(), 'formdata')) {
    delete req.headers['Content-Type'];
  }

  return req;
};

const resInterceptor = (res) => {
  const { data } = res;
  const success = data?.success;
  const errorMsg = data?.errorMsg;
  const dataJson = data?.data;
  const contentTypeHeader = res?.headers?.['content-type'] || '';
  const dispositionHeader = res?.headers?.['content-disposition'];

  const fileNameRaw = dispositionHeader?.split('filename=')?.[1];
  const cleanedFileName = fileNameRaw?.substring(1, (fileNameRaw?.length || 0) - 1);

  if (!contentTypeHeader.startsWith('application/json')) {
    return {
      data,
      contentType: contentTypeHeader,
      filename: cleanedFileName,
    };
  }

  if (success === false) {
    throw new Error(errorMsg || 'Request failed');
  }

  return dataJson;
};

const resErrorInterceptor = (error) => {
  const status = error?.response?.status;
  if (status === 401) {
    store.dispatch('auth/logout');
  }

  if (axios.isAxiosError(error)) {
    const message = error.response?.data?.errorMsg || error.message || 'Request error';
    return Promise.reject(new Error(message));
  }

  return Promise.reject(error);
};

httpClient.interceptors.request.use(reqInterceptor);
httpClient.interceptors.response.use(resInterceptor, resErrorInterceptor);

export default httpClient;
